/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    W002: THREE.Mesh;
  };
  materials: {
    ["W.001"]: THREE.MeshStandardMaterial;
  };
};

export function LetterWModel(
  props: React.ComponentProps<"group"> & {
    color?: string;
    metalness?: number;
    roughness?: number;
  }
) {
  const { color, metalness, roughness, ...groupProps } = props;
  const { nodes, materials } = useGLTF(
    "/models/W.glb"
  ) as unknown as GLTFResult;
  return (
    <group {...groupProps} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.W002.geometry}
        position={[1.223, 0.4, 0.3]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[100.439, 140.439, 100.439]}
      >
        <meshStandardMaterial
          color={color || materials["W.001"].color}
          metalness={
            metalness !== undefined ? metalness : materials["W.001"].metalness
          }
          roughness={
            roughness !== undefined ? roughness : materials["W.001"].roughness
          }
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("/models/W.glb");
